import React from 'react';
import ExpiringCard from '../sales/ExpiringCard';
import WCActivity from '../mobileApp/Activity';
import { userRoles } from '../../../RoleProtected';
import EPActivity from '../expressPass/Activity';
import Usage from '../expressPass/Usage';
import Page from '../../../layout/Page';
import WashClubReport from '../mobileApp/WashClubReport';
import Referral from './Referral';

const Index = ({ ...props }) => {

    return (
        <Page
            title='Subscriptions'
            icon='coins'
            tabs
        >
            <ExpiringCard tab='Expiring Card' roles={userRoles.viewAuditReports} />
            <WashClubReport tab='Wash Club Report' roles={userRoles.viewUsageReports} />
            <WCActivity tab='Wash Club Activity' roles={userRoles.viewUsageReports} />
            <EPActivity tab='ExpressPass Activity' roles={userRoles.viewUsageReports} />
            <Usage tab='ExpressPass Usage' roles={userRoles.viewUsageReports} />
            <Referral tab='Referral' roles={userRoles.viewUsageReports} />
        </Page >
    );
}

export default Index;